import Component from "../abstracts/Component";

export default class AddToWishlistComponent extends Component {
  get SELECTORS() {
    return {
      addToWish: ".js-wishlist-cta",
      notAdded: ".js-addtowish",
      added: ".js-added-wish",
      iconWishList: "#iconWishlist"
    };
  }

  get CLASSES() {
    return {
      show: "show",
      on: "js-added-wish",
      off: "js-addtowish",
      added: "icon-wishlist-on",
      notAdded: "icon-wishlist",
      addBtnClass: "js-add-to-wish"
    };
  }

  constructor() {
    super();

    this.notAdded = $(this.SELECTORS.notAdded);
    this.added = $(this.SELECTORS.added);
    this.addToWish = $(this.SELECTORS.addToWish);
    this.iconWishList = $(this.SELECTORS.iconWishList);
  }

  bindEvents() {
    let ctx = this;

    //click on wishlist
    $("body").on("click.addtowish", ctx.SELECTORS.notAdded, function(e) {
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtowish, $this);
      $this.data("tracking-action", "");
    });

    $("body").on("click.removefromwish", ctx.SELECTORS.added, function(e) {
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, $this);
      $this.data("tracking-action", "wishlistAdd");
    });

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.sizechanged,
      ({ event, payload }) => {
        let code = $(payload.button).data("productCode");
        this.addToWish.data("code", code);
        this.log(code);
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, e => {
      let $cta = $(e.payload);

      $cta.removeClass(this.CLASSES.off).addClass(this.CLASSES.on);
      let contextPath = document
        .getElementsByTagName("HTML")[0]
        .getAttribute("data-context");
      $cta.data("href", contextPath + "/action/miniwishlist/remove");
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, e => {
      let code = $(e.payload).data("code");

      let $cta = "";
      if ($(e.payload).hasClass("js-wishlist-cta")) {
        $cta = $(e.payload);
      } else {
        $cta = $(`.js-wishlist-cta[data-code=${code}]`);
      }
      // $(this.SELECTORS.iconWishList+"-"+code).removeClass(this.CLASSES.added).addClass(this.CLASSES.notAdded);

      $cta.removeClass(this.CLASSES.on).addClass(this.CLASSES.off);
      let contextPath = document
        .getElementsByTagName("HTML")[0]
        .getAttribute("data-context");
      $cta.data("href", contextPath + "/action/ajax/wishlist-add");
    });
  }

  isAddedToWishlist() {
    //check on load to unset tracking action, avoids tracking call on remove-from-wishlist
    const icons = document.querySelectorAll(".js-added-wish");
    icons.forEach(icon => {
      $(icon).data("tracking-action", "");
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    window.addEventListener("load", event => {
      this.isAddedToWishlist();
    });
  }
}
